module.exports = __webpack_public_path__ + "images/cigna-logo_6d6162c.png";